module.exports = __webpack_public_path__ + "static/media/global-show-what-you-know.e63f4cab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global-show-what-you-know.svg
// module id = 152
// module chunks = 0